import { applicationEnum, getLocalizedStrings, stringEnum } from "uicomponents";
import { AppealIdType, AppealPage, AppealType } from "../model/enum";
import { IAppealFormInfo, IAppealInfoResponse, IAppealSubmissionProps } from "../model/interface";

const APPEAL_COMMON_HEADER = 'Appeal.Common.submit-an-appeal';
const APPEAL_COMMON_SUBHEADER = 'Appeal.Common.landing-sub-header';
const APPEAL_ACCOUNT_SUBHEADER_ONE = 'Appeal.Account.landing-overview-line-one'
const APPEAL_ACCOUNT_SUBHEADER_TWO = 'Appeal.Account.landing-overview-line-two'

export const getAppealType = (appealIdType: AppealIdType | undefined) => { 
    switch (appealIdType) {
        case AppealIdType.Job:
            return AppealType.Content;
        default:
            return AppealType.Account;
    }
}

export const getAppealLandingHeader = (appealType: AppealType) => {

    switch (appealType) {
        case AppealType.Content:
            return APPEAL_COMMON_HEADER;
        default:
            return APPEAL_COMMON_HEADER;
    }
}

export const getAppealLandingSubHeader = (appealType: AppealType) => {

    switch (appealType) {
        case AppealType.Account:
            return APPEAL_ACCOUNT_SUBHEADER_ONE;
        case AppealType.Content:
            return APPEAL_COMMON_SUBHEADER;
        default:
            return APPEAL_COMMON_SUBHEADER;
    }
}

export const getAppealLandingSubHeaderTwo = (appealType: AppealType) => {

    switch (appealType) {
        case AppealType.Account:
            return APPEAL_ACCOUNT_SUBHEADER_TWO;
        default:
            return "";
    }
}

export const getDefaultInitialResponseInfo = () => { 
    let defaultInitialResponseInfo: IAppealInfoResponse = {
        appealNumber: "",
        appealIdType: AppealIdType.Unknown,
        appealerName: "",
        contactEmail: "",
        appealDate: "",
        policyViolated: "",
        product: "",
        reportId: "",
        appealerJustification: "",
        eligibilityPeriod: "",
        appealPeriodValid: false,
        hasInitialError: false
    };
    
    return defaultInitialResponseInfo;
}
export const getDefaultAppealFormInfo = () => {
    const defaultFormInfo: IAppealFormInfo = {
        appealNumber: "",
        appealerName: "", 
        contactEmail: "",
        suspendedEmail: "",
        appealerJustification: "", 
        product: "", 
        policyViolated: "",
        reportId: "",
        userId: "",
        hasSubmissionError: false,
        couldFindSuspendedUserId: true,
        shouldAskForProduct: false
    };

    return defaultFormInfo;
}

export const getDefaultAppealSubmissionInfo = () => { 
    const defaultSubmissionInfo: IAppealSubmissionProps = {
        appealType: AppealType.Unknown,
        appealNumber: "",
        appealerName: "",
        contactEmail: "",
        suspendedEmail: "",
        appealDate: "",
        appealerJustification: "",
        policyViolated: "",
        reportId: "",
        userId: "",
        isNewSubmission: true,
        isUpdatedSubmission: false
      };

    return defaultSubmissionInfo;
}

export const getInitialPage = (initialResponse: IAppealInfoResponse) => { 
    if (initialResponse.appealNumber) {
        return AppealPage.Submission;
    }

    else if(!initialResponse.appealPeriodValid) { 
        return AppealPage.Expiry;
    }

    else { 
        return AppealPage.Landing;
    }
}

export const getInitialAppealFormInfo = (initialResponse: IAppealInfoResponse, formId: string | null) => {
    let appealerName = "";
    let contactEmail = "";
    let suspendedEmail = "";
    let appealerJustification = "";
    let product = "";
    let policyViolated = "";
    let reportId = "";

    if (formId && initialResponse) {
        appealerName = initialResponse.appealerName ? initialResponse.appealerName : "";
        contactEmail = initialResponse.contactEmail ? initialResponse.contactEmail : "";
        appealerJustification = initialResponse.appealerJustification? initialResponse.appealerJustification : "";
        product = initialResponse.product ? initialResponse.product : "";
        policyViolated = initialResponse.policyViolated ? initialResponse.policyViolated : "";
        reportId = initialResponse.reportId ? initialResponse.reportId : "";
        
    }

    const initialFormInfo: IAppealFormInfo = {
        appealNumber: "",
        appealerName: appealerName, 
        contactEmail: contactEmail,
        suspendedEmail: suspendedEmail,
        appealerJustification: appealerJustification, 
        product: product, 
        policyViolated: policyViolated,
        reportId: reportId,
        userId: "",
        hasSubmissionError: false,
        couldFindSuspendedUserId: false,
        shouldAskForProduct: false
    };

    return initialFormInfo;
}

export const getProductList = () : Record<string, string> => {
    let products = getLocalizedStrings(stringEnum['products'], applicationEnum['pForms']);
    products["other"] = "Other";
    return products
}

export const isValidBase64Image = (imageString: string) => {
    const base64ImagePattern = new RegExp(/^data:image\/(jpeg|jpg|png|gif);base64,[A-Za-z0-9+/=]+$/);
    return base64ImagePattern.test(imageString);
}

